import * as React from 'react';

import { cssClass } from '../../../style';

const section = cssClass('content-detail-section', 'section', {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  lineHeight: '23px',
});

const header = cssClass('content-detail-section', 'header', {
  textAlign: 'right',
  fontSize: '15px',
  fontWeight: 'normal',
  color: '#999',
  whiteSpace: 'nowrap',
  width: '15%',
  paddingBottom: 12,
  paddingTop: 12,
  paddingRight: 12,
  flexShrink: 0,
});

const detail = cssClass('content-detail-section', 'detail', {
  flexGrow: 1,
  flexShrink: 1,
  borderBottom: '1px solid #e6e6e6',
  paddingTop: 12,
  paddingBottom: 12,
  paddingLeft: 6,
});

const action = cssClass('content-detail-section', 'action', {
  borderBottom: '1px solid #e6e6e6',
  paddingBottom: 12,
  paddingTop: 12,
  paddingRight: 6,
});

export interface DetailSectionProps {
  readonly header: string;
  readonly detail: JSX.Element | string;
  readonly action?: JSX.Element;
}

export function ContentDetailSection(props: DetailSectionProps): JSX.Element {
  return (
    <div className={section}>
      <div className={header}>
        {props.header}
      </div>
      <div className={detail}>
        {props.detail}
      </div>
      <div className={action}>
        {props.action}
      </div>
    </div>
  );
}
